(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["po1-halloween-banner"] && !Shopify.designMode) return;
  try {
    
let po1PreviousPhase=null;
function po1ApplyPhase(){const now=Date.now();const phase=now<Date.parse('2026-10-31T00:00:00+02:00')?'before':now<Date.parse('2026-11-01T00:00:00+02:00')?'event':'after';if(phase===po1PreviousPhase)return;po1PreviousPhase=phase;document.querySelectorAll('[data-po1-phase-copy]').forEach(function(el){if(el.dataset[phase])el.textContent=el.dataset[phase];});document.querySelectorAll('[data-po1-phase-grid]').forEach(function(el){el.hidden=el.dataset.po1PhaseGrid!==(phase==='before'?'before':'event');});document.querySelectorAll('[data-po1-phase-section]').forEach(function(el){el.hidden=phase==='after'&&el.dataset.hideAfter==='true';});const savings=document.getElementById('fashion-savings');const halloween=document.getElementById('halloween-edit');const women=document.getElementById('womens-halloween-picks');const men=document.getElementById('mens-halloween-picks');if(savings&&halloween&&women&&men){const sw=savings.closest('.shopify-section');const hw=halloween.closest('.shopify-section');const ww=women.closest('.shopify-section');const mw=men.closest('.shopify-section');if(sw&&hw&&ww&&mw&&sw.parentElement===hw.parentElement&&sw.parentElement===ww.parentElement&&sw.parentElement===mw.parentElement){if(phase==='before'){sw.insertAdjacentElement('beforebegin',hw);sw.insertAdjacentElement('afterend',ww);ww.insertAdjacentElement('afterend',mw);}else{sw.insertAdjacentElement('afterend',mw);mw.insertAdjacentElement('afterend',ww);ww.insertAdjacentElement('afterend',hw);hw.hidden=phase==='after';}}}}
function po1UpdateCountdown(){po1ApplyPhase();const now=Date.now();document.querySelectorAll('[data-po1-countdown]').forEach(function(el){const remaining=Math.max(0,Math.floor((Date.parse(el.dataset.target)-now)/1000));const units=el.querySelector('[data-countdown-units]');const status=el.querySelector('[data-countdown-status]');const intro=el.querySelector('.po1-countdown__intro');if(remaining===0){units.hidden=true;intro.hidden=true;status.hidden=false;status.textContent=now<Date.parse(el.dataset.eventEnd)?el.dataset.eventLabel:el.dataset.endedLabel;return;}units.hidden=false;intro.hidden=false;status.hidden=true;const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};Object.entries(values).forEach(function(entry){el.querySelector('[data-countdown-'+entry[0]+']').textContent=String(entry[1]).padStart(2,'0');});});}po1UpdateCountdown();document.addEventListener('shopify:section:load',function(){po1PreviousPhase=null;po1UpdateCountdown();});document.addEventListener('visibilitychange',po1UpdateCountdown);setInterval(po1UpdateCountdown,1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
